import { defineChain } from "viem";

/** Native route observed in artifacts/bridge-native-verification. Not write permission. */
export const BRIDGE = {
  id: "native-hype-999-99901-v1",
  parentChainId: 999, childChainId: 99901,
  parentRpc: "https://hyperliquid.drpc.org",
  inbox: "0xce59f8b65ad41c9dae4c07a0571a39824bd92cff",
  bridge: "0x503d572157113faaad4dbed2647bb10b949216b6",
  outbox: "0xec6b106dfa14428fe5eec2a4065a7be599f02728",
  rollup: "0x508c173dfe5f737b3493195bf785d71fa76fd217",
  sequencerInbox: "0x7f3ff53aecb87261206ad3bdc27a88b6d8420fa6",
  arbSys: "0x0000000000000000000000000000000000000064",
  nodeInterface: "0x00000000000000000000000000000000000000c8",
} as const;

export const hyperEvm = defineChain({ id: BRIDGE.parentChainId, name: "HyperEVM",
  nativeCurrency: { name: "HYPE", symbol: "HYPE", decimals: 18 },
  rpcUrls: { default: { http: [BRIDGE.parentRpc] } },
  blockExplorers: { default: { name: "HyperEVM Scan", url: "https://hyperevmscan.io" } },
});

/** Route visibility does not grant transaction permission. */
export function bridgeReviewEnabled(): boolean {
  return import.meta.env.DEV || import.meta.env.VITE_APP_MODE === "DEMO" ||
    import.meta.env.VITE_BRIDGE_REVIEW_ENABLED === "true";
}

/** Explicit deposit-only release gate. DEMO and ordinary production remain closed. */
export function bridgeDepositEnabled(): boolean {
  return import.meta.env.VITE_APP_MODE !== "DEMO" && bridgeReviewEnabled() &&
    import.meta.env.VITE_BRIDGE_DEPOSIT_ENABLED === "true";
}

export function bridgeWithdrawalEnabled(): boolean {
  return import.meta.env.VITE_APP_MODE !== "DEMO" && bridgeReviewEnabled() &&
    import.meta.env.VITE_BRIDGE_WITHDRAWAL_ENABLED === "true";
}
export function bridgeClaimEnabled(): boolean {
  return import.meta.env.VITE_APP_MODE !== "DEMO" && bridgeReviewEnabled() &&
    import.meta.env.VITE_BRIDGE_CLAIM_ENABLED === "true";
}
